import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  background-color: ${props => props.backgroundColor};
`

export const IdentifierContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp16};
  padding-left: 0px;
  color: ${props => props.theme.colors.text.subtle};
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  margin-right: ${props => props.theme.spacing.sp16};
  min-width: 50px;
  align-self: stretch;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${props => props.theme.spacing.sp8};
`

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const DescriptionContainer = styled.div`
  background-color: ${props => props.theme.colors.background.primary};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  padding: ${props => props.theme.spacing.sp8};
  border-radius: 2px;
`

export const MenuItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
